import { Instagram, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { openCookiePreferencesModal } from "@/lib/cookieConsent";
import "./footer.css";

const Footer = () => {
  const email = "hello@usedibs.com";
  const subject = encodeURIComponent("Feedback / Bug Report");
  const body = encodeURIComponent(
    "Hi there,\n\nI would like to report the following issue/share some feedback:\n\n",
  );
  const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;

  return (
    <>
      <footer className="dv-footer">
        <div className="dv-footer__card">
          <div className="dv-footer__grid">
            <div className="dv-footer__brand">
              <a href="#" className="dv-footer__logo">
                <img
                  src="/dibs_assets/red_logo_with_transparent_bg.png"
                  alt="Dibs"
                />
                <span>Dibs</span>
              </a>
              <p>Make every interaction feel remembered.</p>
              <p className="dv-footer__location"><MapPin aria-hidden="true" />Based in Singapore</p>
            </div>
            <div>
              <h4>Quick links</h4>
              <ul>
                <li>
                  <Link to="/auth?mode=login">Admin dashboard</Link>
                </li>
                <li>
                  <a href={mailtoLink}>Feedback / Report bug</a>
                </li>
              </ul>
            </div>
            <div>
              <h4>Company</h4>
              <ul>
                <li>
                  <Link to="/about">About us</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Connect with us</h4>
              <ul>
                <li>
                  <a
                    href="https://instagram.com/dibshq"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Instagram className="w-4 h-4" /> Instagram
                  </a>
                </li>
                <li>
                  <a
                    href="https://tiktok.com/@dibshq"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      className="w-4 h-4"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.06-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.9-.32-1.9-.39-2.81-.12-1.21.32-2.25 1.25-2.61 2.45-.44 1.22-.06 2.64 1 3.52.83.73 1.93 1.02 3.01.83 1.01-.15 1.93-.85 2.32-1.78.3-.74.39-1.57.39-2.37.01-4.96-.01-9.92.01-14.88z" />
                    </svg>
                    TikTok
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="dv-footer__legal">
            <p>
              © 2023 - {new Date().getFullYear()} Dibs Everything Pte Ltd. All
              rights reserved. | UEN: 202418462H
            </p>
            <div className="dv-footer__legal-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span>·</span>
              <Link to="/terms-of-service">Terms of Service</Link>
              <span>·</span>
              <Link to="/data-deletion">Data Deletion</Link>
              <span>·</span>
              <button
                type="button"
                onClick={openCookiePreferencesModal}
                data-testid="footer-cookie-preferences"
              >
                Cookie Preferences
              </button>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
